import React from "react";
import { NavigationalButtons } from "./CreateCourseWizard";
import { Form, Formik } from "formik";
import LearningObjectiveList from "../LearningObjective/LearningObjectiveList";

const LearningObjectiveStep = ({ courseId, revId, nextOnClick, prevOnClick }) => {

    return (
        <div style={{width: 1200}}>
            <LearningObjectiveList crsId={courseId} revId={revId} />
            <Formik
                initialValues={{}}
                onSubmit={async () => {
                    nextOnClick();
                }}
            >
                <Form>
                    <NavigationalButtons
                        onNextProps={{ type: "submit", text: "Save and Continue" }}
                        onPrevHandler={prevOnClick}
                    />
                </Form>
            </Formik>
        </div>
    );
};

export default LearningObjectiveStep;
